import { createApp } from 'vue'
import Antd from 'ant-design-vue'

import App from './App'
import router from './router'
import store from './store'
import { loadStyle } from './utils'
import 'ant-design-vue/dist/antd.less'

loadStyle('//at.alicdn.com/t/c/font_285533_yekz4va93nl.css')

import '@/vab'

/**
 * @author mht 401285685@qq.com
 * @description 挂载全局自定义项目图标
 */
import { createFromIconfontCN } from '@ant-design/icons-vue'
const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_285533_lv6moybl2k.js',
})

/**
 * @author mht 401285685@qq.com
 * @description Vant 国际化
 */

import { Locale } from 'vant'
import enUS from 'vant/es/locale/lang/en-US'
Locale.use('en-US', enUS)

createApp(App)
  .use(store)
  .use(router)
  .use(Antd)
  .component('icon-font', IconFont)
  .mount('#app')
